import { Button } from '@hologram-dimension/button';
import { useClearRefinements, useInstantSearch } from 'react-instantsearch';
import type { ProfilesDaoSimProfileDetails } from 'types/__generated__/SimInventoryApi';
import { SingleLegacyPlan } from 'types/legacyDashboard';
import styles from './Filters.module.css';
import ProfileFilter from './ProfileFilter/ProfileFilter';
import RefinementList from './RefinementList';

interface FiltersProps {
  simProfiles?: ProfilesDaoSimProfileDetails[];
  planProfiles?: SingleLegacyPlan['profiles'];
}

const Filters = ({ simProfiles, planProfiles }: FiltersProps) => {
  const { canRefine } = useClearRefinements();
  const { indexUiState, setIndexUiState } = useInstantSearch();

  return (
    <>
      <div className={styles.titleWrapper}>
        <span className={styles.title}>Filters</span>
        {(canRefine || indexUiState.query) && (
          <Button
            noPadding
            variant="tertiary"
            onClick={() =>
              // Reset all filters except sorting
              setIndexUiState((prevIndexUiState) => ({ sortBy: prevIndexUiState.sortBy }))
            }
          >
            Reset
          </Button>
        )}
      </div>
      <ProfileFilter simProfiles={simProfiles} planProfiles={planProfiles} />
      <RefinementList attribute="supported_rat" sortBy={['name']} />
      <RefinementList attribute="country" />
    </>
  );
};

export default Filters;
